/**
 * Import classes
 */
import FormatNumber from '../../modules/format/number';
import RequiredValidation from '../../modules/validation/requiredValidation';
import PhoneValidation from '../../modules/validation/phoneValidation';
import DisabledHandler from '../../modules/validation/disabledHandler';
import StringValidation from '../../modules/validation/stringValidation';
import DomainSuggest from '../../modules/email/domainSuggest';

/**
 * Make instances
 */
const formatNumber = new FormatNumber();
const required = new RequiredValidation();
const phoneValidation = new PhoneValidation();
const stringValidation = new StringValidation();
const disabledHandler = new DisabledHandler();
const domainSuggest = new DomainSuggest();
const consultationRadioBtns = document.getElementsByClassName('js-radio') as HTMLCollectionOf<HTMLOptionElement>;
const consultationContent = document.getElementsByClassName('js-consultation')[0];
for (let i = 0; i < consultationRadioBtns.length; i++) {
  const radio = consultationRadioBtns[i];
  radio.addEventListener('change', () => {
    if (radio.value === 'infomation') {
      consultationContent.classList.remove('is-hidden');
    } else {
      consultationContent.classList.add('is-hidden');
    }
  });
}
/**
 * Execute functions
 */
// 数字フォーマット
formatNumber.onChange();
// 必須項目バリデーション
required.validate();
// 文字列バリデーション
stringValidation.validate();
// 電話番号バリデーション
phoneValidation.validate();
// submitボタンクリッカブル操作
disabledHandler.validate();
// Emailドメイン自動補完
domainSuggest.enableSuggestion();
